import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col, Button, Row } from 'reactstrap';
import { Field, } from 'redux-form';
import renderSelectField from '../../../../../../shared/components/form/Select';
import TextField from '@material-ui/core/TextField';
import moment from 'moment';
import history from '../../../../../../history';
import PrintIcon from '@material-ui/icons/Print';
import PrintsProceduresPDF from '../PrintsProceduresPDF';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import SelectorTemplate from '../SelectorTemplate';
import renderFileInputField from '../../../../../../shared/components/form/FileInput';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFile, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import Tooltip from '@material-ui/core/Tooltip';

const renderField = ({
  input, placeholder, type, meta: { touched, error },
}) => (
  <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above">
    <input {...input} placeholder={placeholder} type={type} />
    {touched && error && <span className="form__form-group-error">{error}</span>}
  </div>
);

renderField.propTypes = {
  input: PropTypes.shape().isRequired,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
};

renderField.defaultProps = {
  placeholder: '',
  meta: null,
  type: 'text',
};

class Stress extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      dataMedications: [],
      specialists: [],
      specialty: '',
      professionals: [],
      professional: {},
      addedDiagnostics: [],
      openModal: false,
      loadProfessionals: false,
      vid: "",
      pp: "",
      ps: "",
      vis: "",
      fe: "",
      rao: "",
      ao: "",
      anillo_oa: "",
      vd: "",
      ai: "",
      a: "",
      e: "",
      tap_se: "",
      ad: "",
      description: "",
      conclusions: "",
      diagnostico: "",
      descripcion_d: "",
      profile: sessionStorage.getItem('perfil'),
      stressFiles: []
    }
  }

  componentDidMount() {
    console.log(this.state.professional)
    //this.getData();
    this.getDataIndividually();
  }

  checkForFilesByThisProcedure = () => {
    let stressFiles = this.props.filesProcedures.filter((file) => file.procedure === 'Stress');
    this.setState({ stressFiles })
  }

  componentDidUpdate(prevProps) {
    if (JSON.stringify(prevProps.filesProcedures) !== JSON.stringify(this.props.filesProcedures))
      this.checkForFilesByThisProcedure()
  }


  getDataIndividually = () => {

    this.setState({ loadProfessionals: true }, async () => {
      let specialistList = await this.fetchDataSpecialist();
      let professionales = await this.fetchDataProfessionals();
      console.log("specialistList", specialistList, "professionales", professionales);
      if(!!specialistList && this.props.id_professionalFromEvent !== null){
        let id_specialty = "";
        professionales.map((professional) => {
          if (professional.id_profesional === this.props.id_professionalFromEvent) {
            id_specialty = professional.id_especialidad
          }
        });
        this.setState({ specialty: id_specialty }, () => {
          this.setState({ professional: this.props.professional, loadProfessionals: false });
          this.props.handlerMedicalProcedures("Stress", "professional", this.props.professional);
        });
      }
    })
  }

  getData = () => {
    this.setState({ loadProfessionals: true }, () => {
      Promise.all([this.fetchDataSpecialist(), this.fetchDataProfessionals()]).then((result) => {
        this.setState({ specialists: result[0], professionals: result[1] }, () => {
          if (this.props.professional !== null) {
            var id_specialty = "";
            result[1].map((professional) => {
              if (professional.id_profesional === this.props.professional) {
                id_specialty = professional.id_especialidad
              }
            });
            this.setState({ specialty: id_specialty, professional: this.props.professional, loadProfessionals: false });
          }
        });
      })
        .catch(error => console.log(`Error in promises ${error}`));
    })
  }

  fetchDataSpecialist = () => {
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + 'especialidad/listar', {
        method: 'GET',
        headers: {
          authorization: 'Bearer ' + sessionStorage.getItem('token'),
        }
      })
        .then(response => {
          return response.json();
        })
        .then(specialists => {
          resolve(specialists);
        })
        .catch((error) => {
          reject(error)
        });
    });
  };

  fetchDataProfessionals = () => {
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + 'profesional/listar', {
        method: 'GET',
        headers: {
          authorization: 'Bearer ' + sessionStorage.getItem('token'),
        }
      })
        .then(response => {
          return response.json();
        })
        .then(professionals => {
          resolve(professionals);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  saveProcedure() {

    const day = new Date();
    const data = {
      id_historia: this.props.data.id_historia,
      id_admision: this.props.data.id_admision,
      fecha: moment(day).format("YYYY-MM-DD"),
      hora: moment(day).format('LT'),
      eco: {
        profesional: "",
        vid: "",
        pp: "",
        ps: "",
        vis: "",
        fe: "",
        rao: "",
        anillo_oa: "",
        vd: "",
        ai: "",
        a: "",
        e: "",
        tap_se: "",
        ad: "",
        resposo: "",
        ejercicio: "",
        conclusions: "",
        diagnostico: "",
        descripcion_d: ""
      },
      stress: {
        profesional: this.props.professional.nombres + " " + this.props.professional.apellido1,
        vid: this.state.vid,
        pp: this.state.pp,
        ps: this.state.ps,
        vis: this.state.vis,
        fe: this.state.fe,
        rao: this.state.rao,
        ao: this.state.ao,
        anillo_oa: this.state.anillo_oa,
        vd: this.state.vd,
        ai: this.state.ai,
        a: this.state.a,
        e: this.state.e,
        tap_se: this.state.tap_se,
        adult: this.state.adult,
        description: this.state.description,
        conclusions: this.state.conclusion,
        diagnostico: this.state.addedDiagnostics,
        descripcion_d: "",
      },
      prueba: {
        professional: "",
        conclusiones: "",
        conclusions: "",
        diagnostico: "",
        descripcion_d: ""
      },
      ekg: {
        professional: "",
        ritmo: "",
        fc: "",
        ondaP: "",
        pr: "",
        qr_s: "",
        eje_qrs: "",
        styt: "",
        qtc: "",
        conclusions: "",
        diagnostico: "",
        descripcion_d: ""
      },
      holter: {
        professional: "",
        conclusion: "",
        medicament: "",
        descripcion_d: ""
      },
      map: {
        professional: "",
        conclusion: "",
        diagnostico: "",
        descripcion_d: ""
      },
    }

    console.log(data);

    fetch(process.env.REACT_APP_PUBLIC_URL + 'procedimientos/create', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      },
      body: JSON.stringify(data)
    })
      .then(response => {
        return response.json();
      })
      .then(data => {
        console.log(data);
        alert("procedimiento creado correctamente");
        history.push({
          pathname: process.env.PUBLIC_URL + '/pages/search-clinic-history',
        });
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }


  handlerSpeciality = (event) => {
    this.setState({ specialty: event.target.value });
  }

  handlerProfessional = (professional) => {
    console.log(professional);
    this.setState({ professional: professional });
  }

  handlerConclusion = (conclusions) => {
    this.setState({ conclusions: conclusions });
  }

  handlerDescription = (description) => {
    this.setState({ description: description });
  }

  handlerAdult = (adult) => {
    this.setState({ adult: adult });
  }

  handlerFe = (fe) => {
    this.setState({ fe: fe });
  }

  handlerAd = (ad) => {
    this.setState({ ad: ad });
  }

  handlerAi = (ai) => {
    this.setState({ ai: ai });
  }

  handlerVis = (vis) => {
    this.setState({ vis: vis });
  }

  handlerTapse = (tap_se) => {
    this.setState({ tap_se: tap_se });
  }

  handlerVd = (vd) => {
    this.setState({ vd: vd })
  }

  handlerPs = (ps) => {
    this.setState({ ps: ps })
  }

  handlerA = (a) => {
    this.setState({ a: a });
  }

  handlerAo = (ao) => {
    this.setState({ ao: ao });
  }

  handlerPp = (pp) => {
    this.setState({ pp: pp });
  }

  handlerE = (e) => {
    this.setState({ e: e });
  }

  handlerRao = (rao) => {
    this.setState({ rao: rao });
  }

  handlerVid = (vid) => {
    this.setState({ vid: vid });
  }

  printPDF = async () => {
    await this.props.saveProceduresPatient().then((saved) => {
      if (saved) {
        PrintsProceduresPDF.printPDF(this.props.id_admision, "STRESS");
      }
    }).catch((err) => {
      console.log(err);
    })
  }

  onChangeTemplate = (template) => {
    if (template != null && template != undefined) {
      this.props.handlerMedicalProcedures("Stress", "conclusions", template.contenido, "nameTemplete", template.plantilla);
      //this.props.handlerNameTemplete("Stress", "nameTemplete", template.plantilla);
      this.handlerConclusion(template.contenido);
    }
  }

  handlerTextfieldFileProcedure = (e) => {
    console.log("WHATISTHISndTime", e);
    this.props.handlerFileProcedure(e.target.files[0], this.props.dataProcedure.id_servicio);
    //this.inputFileTestRef.current.value = null
  }

  render() {

    return (
      <Col>
        <div className="form" style={{ flex: 1, flexDirection: 'column' }}>
          <div className="card__title">
            <h5 className="bold-text">Estres</h5>
          </div>

          <Row>
            <Col md={6}>
              <SelectorTemplate
                typeProcedure={3}
                onChangeTemplate={(template) => {
                  this.onChangeTemplate(template);
                }}
                disabled={this.props.isCloseClinicHistory}
              />
            </Col>
          </Row>
          <br />


          <div style={{ flex: 1, flexDirection: 'row', marginBottom: 20 }}>
            <TextField
              required
              disabled
              id="specilaity-standard-required"
              label="Especialidad"
              type="text"
              value={typeof this.props.professional.especialidad === 'undefined' ? "" : this.props.professional.especialidad}
              onChange={(e) => {
                this.handlerSpeciality(e.target.value);
              }}
            />
            <TextField
              required
              disabled
              id="professional-standard-required"
              label="Profesional"
              type="text"
              value={`${this.props.professional.nombres} ${this.props.professional.apellido1}`}
              onChange={(e) => {
                this.handlerProfessional(e.target.value);
              }}
            />
          </div>

          <div className="Form">

            <div style={{ margin: 10 }}>
              <CKEditor
                style={{ width: '100%', height: '200px' }}
                editor={ClassicEditor}
                disabled={this.props.isCloseClinicHistory}
                data={this.props.dataProcedure.conclusions != null ? this.props.dataProcedure.conclusions : ''}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  this.props.handlerMedicalProcedures("Stress", "conclusions", data);
                    this.handlerConclusion(data);
                }}
              />
            </div>
          </div>
        </div>
        <Button
          style={{ marginTop: 20 }}
          color="primary"
          disabled={this.props.isCloseClinicHistory}
          onClick={() => { this.printPDF() }}
        >
          Guardar e Imprimir
        </Button>
        {!!this.props.dataProcedure.stressFiles &&
          !!this.props.dataProcedure.stressFiles.length ?
          this.props.dataProcedure.stressFiles.map(stressFile => (
            <div style={{ margin: '0em 2em' }} key={stressFile.id_procedimiento_adjunto}>
              <div>
                <b>{stressFile.adjunto}</b>
              </div>
              <Tooltip title="Ver Documento">
                <Button
                  className="btn btn-sm"
                  color="primary"
                  onClick={() => {
                    window.open(stressFile.wholeUrl, '_blank');
                  }}
                >
                  <FontAwesomeIcon icon={faFile} />
                </Button>
              </Tooltip>
              <Tooltip title="Eliminar Documento">
                <Button
                  className="btn btn-sm"
                  color="danger"
                  onClick={() => {
                  this.props.deleteFileProcedure(stressFile.id_admision, stressFile.id_servicio, stressFile.procedure);
                  }}
                >
                  <FontAwesomeIcon icon={faTrashAlt} />
                </Button>
              </Tooltip>
            </div>
          ))
          : <div>
            <span className="form__form-group-label">
              Agregar adjunto
            </span>
            <div >
            <TextField
              id="file-procedure-test-standard-required"
              type="file"
              variant="outlined"
              className="material-form__field"
              //ref={this.inputFileTestRef}
              inputProps={{
                multiple: false
              }}
              onChange={(e) => {
                this.handlerTextfieldFileProcedure(e);
              }}
            />
              {/* <Field
                name="file-medical-procedure"
                component={renderFileInputField}
                onChange={(e) => {
                  console.log("WHATISHERE", e)
                  this.props.handlerFileProcedure(e, this.props.dataProcedure.id_servicio)
                }}
              /> */}
            </div>
          </div>}
      </Col>
    )
  }
}

export default Stress;